/* 用户相关接口 */
import http from "./request";

// 分页接口
export function getElecPriceStrategyTemplatePage(params) {
	return http("/elecPriceStrategyTemplate/page", {
		method: "POST",
		params: params,
	});
}

// 新增编辑策略
export function editElecPriceStrategyTemplatePage(params) {
	return http("/elecPriceStrategyTemplate/saveOrUpdate", {
		method: "POST",
		params: params,
	});
}

// 获取

// 删除策略
export function deleteElecPriceStrategyTemplatePage(id) {
	return http(`/elecPriceStrategyTemplate/remove/${id}`, {
		method: "delete",
		params: {},
	});
}

// 获取策略列表
export function getElecPriceStrategyTemplatePageList() {
	return http("/elecPriceStrategyTemplate/list", {
		method: "GET",
		params: {},
	});
}
